export default "__VITE_ASSET__BtDEZA1W__"